module.exports = __webpack_public_path__ + "img/en.bb2ef04b.png";